import { IAppProps } from '@interfaces/App.interface';
import { GridContainerFullHeight, Typography } from '@ts/storybook';
//@ts-ignore
import Img from '../public/assets/landing.png';
//@ts-ignore
import Logo from '../public/assets/logo/track_sphere_logo_white_rev.svg';

interface ILandingPageProps extends IAppProps {}

const LandingPage = (props: ILandingPageProps) => {
  return (
    <GridContainerFullHeight
      id="LandingPage"
      sx={{
        position: 'absolute',
        top: 64,
        zIndex: '11!important',
        height: 'calc(100vh - 64px)',
        width: 'calc(100vw - 64px)',
        backgroundImage: `url(${Img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="absolute top-0 left-0 w-full h-full bg-primary-main opacity-40" />
      <Typography
        variant="h2"
        text={['Welcome to', <img src={Logo} alt="Logo" className={'ml-3'} />]}
        className="text-white w-max font-bold flex items-end justify-center"
        sx={{ position: 'absolute', top: '54%', left: '50%', transform: 'translate(-50%, -50%)' }}
      />
    </GridContainerFullHeight>
  );
};

export default LandingPage;
